// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import {
//   FaBatteryFull,
//   FaShieldAlt,
//   FaChargingStation,
//   FaLeaf,
//   FaWifi,
//   FaFan,
//   FaTools,
//   FaPlug,
// } from "react-icons/fa";
// import parse from "html-react-parser";

// class CategoryInverters extends Component {
//   render() {
//     let publicUrl = process.env.PUBLIC_URL + "/";
//     let imagealt = "image";

//     return (
//       <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-70">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">
//               <div className="section-title-area ltn__section-title-2--- text-center">
//                 <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
//                   Smart, Safe, Powerful Performance
//                 </h6>
//                 <h1 className="section-title">Key Features</h1>
//               </div>
//             </div>
//           </div>
//           <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center go-top">
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     {/* <i className="flaticon-car" /> */}
//                     <FaChargingStation color="#0D5540" size={30} />
//                   </span>
//                   <span className="category-number">01</span>
//                   <span className="category-title">Long Cycle Life</span>
//                   <span className="category-brief">
//                     Enjoy long-lasting power with a our ATOM Power battery
//                     designed for an extended cycle life
//                   </span>
//                   <span className="category-btn d-none">
//                     {/* <i className="flaticon-right-arrow" /> */}
//                     <FaChargingStation color="#0D5540" size={40} />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-swimming" />
//                   </span>
//                   <span className="category-number">02</span>
//                   <span className="category-title">Advanced BMS</span>
//                   <span className="category-brief">
//                     {/* We are dedicated to sustainability with eco-friendly
//                     batteries that lower your carbon footprint. */}
//                     An Advanced BMS keeps your battery running safely and
//                     efficiently, maximizing its lifespan and performance.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-secure-shield" />
//                   </span>
//                   <span className="category-number">03</span>
//                   <span className="category-title">
//                     Fast Charging/  Discharging
//                   </span>
//                   <span className="category-brief">
//                     ATOM Power delivers fast charging and discharging for energy
//                     when you need it.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-stethoscope" />
//                   </span>
//                   <span className="category-number">04</span>
//                   <span className="category-title">
//                     Environmentally Friendly
//                   </span>
//                   <span className="category-brief">
//                     ATOM Power offers eco-friendly batteries that reduce your
//                     carbon footprint.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-book" />
//                   </span>
//                   <span className="category-number">05</span>
//                   <span className="category-title">Remote Monitoring</span>
//                   <span className="category-brief">
//                     ATOM Power allows remote monitoring for full control and
//                     insights.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-bed-1" />
//                   </span>
//                   <span className="category-number">06</span>
//                   <span className="category-title">Quiet Operation</span>
//                   <span className="category-brief">
//                     ATOM Power ensures quiet operation, providing seamless
//                     energy without the noise.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link
//                 // to="/shop"
//                 >
//                   <span className="category-icon">
//                     <i className="flaticon-home-2" />
//                   </span>
//                   <span className="category-number">07</span>
//                   <span className="category-title">WiFi Enabled</span>
//                   <span className="category-brief">
//                     ATOM Power’s WiFi-enabled batteries offer easy connectivity
//                     and remote control for convenience
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//             <div className="col-lg-3 col-md-4 col-sm-6 col-6">
//               <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
//                 <Link to="/shop">
//                   <span className="category-icon">
//                     <i className="flaticon-slider" />
//                   </span>
//                   <span className="category-number">08</span>
//                   <span className="category-title">
//                     Compatible With Inverters
//                   </span>
//                   <span className="category-brief">
//                     Works with solar inverters, making it easy to integrate into
//                     existing solar setups.
//                   </span>
//                   <span className="category-btn d-none">
//                     <i className="flaticon-right-arrow" />
//                   </span>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default CategoryInverters;

import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  FaBatteryFull,
  FaShieldAlt,
  FaChargingStation,
  FaLeaf,
  FaWifi,
  FaFan,
  FaTools,
  FaPlug,
  FaCogs,
  FaHandsHelping,
  FaLightbulb,
  FaThermometerHalf,
} from "react-icons/fa";

class CategoryEBikeBattery extends Component {
  render() {
    const featureData = [
      {
        id: 1,
        title: "Lasting Power",
        description:
          "Enjoy years of reliable energy with a battery designed for over 3000 charge cycles, ensuring long-term performance.",
        icon: <FaBatteryFull color="#0D5540" size={40} />,
      },
      {
        id: 2,
        title: "Advanced BMS",
        description:
          "Our advanced battery management system delivers consistent and clean backup power, optimizing performance and reliability.",
        icon: <FaPlug color="#0D5540" size={40} />,
      },
      {
        id: 3,
        title: "Fast Charge/Discharge",
        description:
          "Quickly replenish power and utilize a high percentage of the battery's capacity when you need it most.",
        icon: <FaChargingStation color="#0D5540" size={40} />,
      },
      {
        id: 4,
        title: "Maintenance-Free",
        description:
          "Contribute to a sustainable future with our environmentally friendly design that requires absolutely no maintenance.",
        icon: <FaLeaf color="#0D5540" size={40} />,
      },
      // {
      //   id: 5,
      //   title: "Remote Monitoring",
      //   description: "Monitor your system's status from anywhere.",
      //   icon: <FaWifi color="#0D5540" size={40} />,
      // },
      {
        id: 6,
        title: "Temperature Resistant",
        description:
          "Designed to maintain performance across a range of temperatures.",
        icon: <FaThermometerHalf color="#0D5540" size={40} />,
      },
      {
        id: 7,
        title: "UN 38.3 Certified",
        description:
          "Meets rigorous safety standards for transportation and use.",
        icon: <FaShieldAlt color="#0D5540" size={40} />,
      },
      {
        id: 8,
        title: "Quiet Operation",
        description: "Enjoy silent power without disruptive noise.",
        icon: <FaFan color="#0D5540" size={40} />,
      },
    ];

    return (
      <div className="ltn__category-area ltn__product-gutter section-bg-1--- pt-115 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">
                  Smart, Safe, Powerful Performance
                </h6>
                <h1 className="section-title">Key Features</h1>
              </div>
            </div>
          </div>

          <div className="row ltn__category-slider-active--- slick-arrow-1 justify-content-center go-top">
            {featureData.map((feature) => (
              <div
                key={feature.id}
                className="col-lg-3 col-md-4 col-sm-6 col-6"
              >
                <div className="ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
                  <Link
                    to="#"
                    onClick={(e) => e.preventDefault()}
                    style={{
                      pointerEvents: "none", // optional: disables hover click, fully non-interactive
                      textDecoration: "none",
                      color: "inherit",
                      display: "block",
                      cursor: "default", // optional: removes pointer cursor
                    }}
                  >
                    <span className="category-icon">{feature.icon}</span>
                    <span className="category-number">
                      {feature.id.toString().padStart(2, "0")}
                    </span>
                    <span className="category-title">{feature.title}</span>
                    <span className="category-brief">
                      {feature.description}
                    </span>
                    <span className="category-btn d-none">{feature.icon}</span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default CategoryEBikeBattery;
